import { DashboardTab as PoWorkflowDashboardTab } from '../POWorkflowManagement/DashboardTab';
import { getApprovalPersonPoWorkflowDashboard } from './functions/get_po_workflow_dashboard.function';

export const DashboardTab = () => (
  <PoWorkflowDashboardTab
    fetchDashboard={getApprovalPersonPoWorkflowDashboard}
    showPoSummary={false}
  />
);
